import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie'
import { Grid, Typography, Box, Button, FormControl, InputLabel, Input, FormHelperText } from '@mui/material';
import { Outlet } from 'react-router-dom';
import SideTabs from "../components/sideTabs";
import { transactionClicked, searchId, notOps } from "../store/gloabalState";
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';

export default function Dashboard() {
    // const userName = useRecoilValue(userInfo);
    const [transactionId, setTransactionId] = useRecoilState(transactionClicked);
    const [searchInput, setSearchInput] = useRecoilState(searchId);
    const [userName, setUserName] = useState();
    const [refresh, setRefresh] = useState(false);
    // const [notOps, setNotOps] = useState(false)
    const [notOps_, setNotOps_] = useRecoilState(notOps)
    let navigate = useNavigate();
    const [error, setError] = useState('');

    const searchTransactionId = (e) => {
        e.preventDefault();
        if(!error && searchInput.trim().length){
            setTransactionId(searchInput)
            navigate(`/transactiondetail/${searchInput}`)
            setSearchInput("");            
        }
    }
    useEffect(() => {
        setTimeout(() => {
            let userInfo = Cookies.get("userInfo");
            let accessToken = Cookies.get("accessToken");
            if (userInfo) {
                userInfo = JSON.parse(userInfo);
                setUserName(userInfo.name);
                setRefresh(true)
                if (userInfo.userType === "BD" || userInfo.userType === "AM" || userInfo.userType === "BD_CHECKER") {
                    setNotOps_(true)
                }
            }
        }, 100)
    }, [])
    useEffect(() => {
        if (refresh) {
            setRefresh(false)
        }
    }, [userName, refresh])

    // Function to check if input contains special characters
    const hasSpecialCharacters = (value) => {
        const specialCharRegex = /[^a-zA-Z0-9\s]/g;
        return specialCharRegex.test(value);
    };

    return (
        <Grid container spacing={2} className='dashboardpage'>
            <SideTabs />
            <Grid item xs={10} sx={{ marginLeft: "240px" }}>
                <Box sx={{ display: "flex", border: "1px solid #9c9696", borderRadius: "4px", pr: "1rem", mb: "1rem" }}>
                    <Typography variant="h4" sx={{ padding: "1rem" }}>Hello <span className='username'>{userName}</span>,</Typography>
                    {
                        !notOps_ &&
                        <Box component={"form"} sx={{ marginLeft: "auto" }} onSubmit={(e) => searchTransactionId(e)}>
                            <FormControl required variant="standard" sx={{ dispaly: "flex", alignItems: "center", marginRight: "1rem", marginTop: ".5rem", width: 200 }} error={!!error}>
                                <InputLabel htmlFor="searchbox">Search Transaction ID</InputLabel>
                                <Input
                                    id="searchbox"
                                    inputProps={{ "data-testid": "homepage-input", "maxLength":"100" }}
                                    sx={{ width: "100%" }}
                                    value={searchInput}
                                    onChange={(e) => {
                                        setSearchInput(e.target.value)
                                        if (hasSpecialCharacters(e.target.value)) {
                                            setError('Special characters are not allowed');
                                          } else {
                                            setError('');
                                          }
                                    }} />
                                    {error && <FormHelperText>{error}</FormHelperText>}
                            </FormControl>
                            <Button
                                variant="contained"
                                inputProps={{ "data-testid": "homepage-button" }}
                                data-testid="homepage-button"
                                type="submit"
                                sx={{ margin: "1rem 0" }}>
                                Search
                            </Button>
                        </Box>
                    }
                </Box>
                <Outlet />
            </Grid>
        </Grid>
    );
}